module.exports = __webpack_public_path__ + "img/twistie-up.f0b9e94b.svg";